<template>
  <div class="d-flex align-center">
    <v-text-field
      v-model="text"
      placeholder="Author(s)"
      hide-details
      class="text-body-2 font-weight-light pt-0 mt-0"
      :autofocus="autofocus"
    />
    <v-btn v-if="!hideRemove" icon small>
      <v-icon color="error" @click="$emit('remove')">
        remove_circle
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AuthorInputField',
  props: {
    value: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    hideRemove: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
